import React from 'react'
import './SubCheckout.css'
import CurrencyFormat from 'react-currency-format'
import { useStateValue } from '../StateProvider'
import { getCartTotal } from '../reducer';
function SubCheckout() {
   const [{cart},dispatch]= useStateValue();
  return (
    <div className='subtotal'>
        <CurrencyFormat
        renderText={(value)=>(
            <>
            <p>
                SubTotal ({cart.length} items):<strong>{`${value}`}</strong>
            </p>
            <small className='subtotal_gift'>
                <input type="checkbox" />This Order Contains a gift
            </small>
            </>
        )}
        decimalScale={2}
        value={getCartTotal(cart)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={"₹"}
        />
        <button>Proceed To CheckOut</button>
      
    </div>
  )
}

export default SubCheckout
